import React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

/**
 * The site key for the signup bot-protection challenge.
 *
 * SHIP-DARK: `REACT_APP_SIGNUP_RECAPTCHA_SITE_KEY` is not set today, because the
 * client does not have Firebase/GCP console access yet. With it unset this
 * component renders `null` and the signup forms are pixel-identical to before
 * item 01. The backend guard is independently inert
 * (`SIGNUP_RECAPTCHA_MODE=off`), so an unchallenged signup is still accepted.
 */
export const SIGNUP_RECAPTCHA_SITE_KEY = process.env.REACT_APP_SIGNUP_RECAPTCHA_SITE_KEY;

/**
 * The signup bot-protection challenge widget.
 *
 * Shared by the two live Firebase signup forms —
 * `components/auth/auth-popup-form/SignupForm.js` (the auth popup and the
 * `/login` signup panel) and `components/redeem_coupon/SignupForm.js` (the
 * `/coupon/:event` and `/influencer/:event` pages). It is deliberately NOT on
 * the login forms: this protects account creation, not sign-in.
 *
 * Note this widget protects the BEAUTRIUM database, not Firebase. A bot that
 * already holds a Firebase ID token has an account in Firebase Auth regardless;
 * only reCAPTCHA Enterprise inside Identity Platform stops that, and it is
 * enforced on Google's side of the trust boundary. Both layers are needed and
 * neither substitutes for the other.
 *
 * @param {object} props
 * @param {function(string|null): void} props.onChange - Receives the challenge
 *        token, or `null` when the widget expires and the user must redo it.
 * @returns {React.ReactElement|null} `null` when no site key is configured.
 */
const SignupChallenge = ({ onChange }) => {
    if (!SIGNUP_RECAPTCHA_SITE_KEY) {
        return null;
    }

    return (
        <div className="signup-challenge">
            <ReCAPTCHA sitekey={SIGNUP_RECAPTCHA_SITE_KEY} onChange={onChange} />
        </div>
    );
};

export default SignupChallenge;
